export default "__VITE_ASSET__619584$7__"